import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const DataLoader: React.FC = () => {
    return (
        <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-75 z-50">
            <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};

export default DataLoader;
